import React from 'react';
import { Upload } from 'lucide-react';

interface MediaManagerProps {
  detectedImages: { id: string; src: string; type: 'img' | 'bg' }[];
  onReplaceImage: (id: string) => void;
}

export const MediaManager: React.FC<MediaManagerProps> = ({ detectedImages, onReplaceImage }) => {
  return (
    <div className="space-y-4 p-6">
      <h3 className="text-[10px] font-semibold text-gray-500 uppercase tracking-widest">Imagens do Site</h3>
      
      {detectedImages.length === 0 ? (
        <div className="text-center py-8 text-gray-400 text-sm">
          Nenhuma imagem detectada.
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-4">
          {detectedImages.map((img, idx) => (
            <div key={idx} className="group relative rounded-lg border border-gray-200 bg-gray-50 overflow-hidden aspect-square flex items-center justify-center">
              <img src={img.src} alt="Media" className="max-w-full max-h-full object-contain p-2" />
              
              <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                 <button 
                   onClick={() => onReplaceImage(img.id)} 
                   className="bg-white text-black text-xs font-medium px-3 py-2 rounded-md flex items-center gap-2 shadow-lg transform scale-95 group-hover:scale-100 transition-all"
                 >
                   <Upload size={14} /> Trocar
                 </button>
              </div>
              
              {img.type === 'bg' && (
                <div className="absolute top-2 left-2 bg-black/60 text-white text-[9px] px-1.5 py-0.5 rounded uppercase font-semibold tracking-wider">
                  Fundo
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
